import { Conversation } from "../types/chat";
import { conversationTitle } from "../services/conversationStorage";

interface ChatHistoryListProps {
  conversations: Conversation[];
  activeId: string;
  onSelect: (id: string) => void;
  onDelete?: (id: string) => void;
  disabled?: boolean;
}

export function ChatHistoryList({
  conversations,
  activeId,
  onSelect,
  onDelete,
  disabled,
}: ChatHistoryListProps) {
  if (conversations.length === 0) {
    return (
      <p className="px-1 text-xs text-white/40">No saved conversations yet.</p>
    );
  }

  return (
    <ul className="space-y-1">
      {conversations.map((c) => {
        const active = c.conversationId === activeId;
        return (
          <li key={c.conversationId} className="group flex items-stretch gap-1">
            <button
              type="button"
              disabled={disabled}
              onClick={() => onSelect(c.conversationId)}
              className={`min-w-0 flex-1 rounded-lg px-2 py-2 text-left text-xs transition ${
                active
                  ? "bg-white/15 text-white"
                  : "text-white/70 hover:bg-white/10 hover:text-white"
              } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
            >
              <span className="block truncate font-medium">{conversationTitle(c)}</span>
              <span className="block truncate text-[10px] text-white/40">
                {new Date(c.updatedAt).toLocaleString()}
                {c.customerName ? ` · ${c.customerName}` : ""}
              </span>
            </button>

            {onDelete && (
              <button
                type="button"
                title="Delete conversation"
                aria-label="Delete conversation"
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm("Delete this conversation?")) {
                    onDelete(c.conversationId);
                  }
                }}
                className={`rounded-lg px-2 text-sm text-white/40 transition hover:bg-white/10 hover:text-red-300 ${
                  active ? "opacity-100" : "opacity-0 group-hover:opacity-100"
                } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
              >
                ×
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
